import { useTranslation } from "react-i18next";
import React from "react";
import { Button, CheckCircleOutlined, CloseCircleOutlined, CloseOutlined, ExclamationCircleOutlined, Modal } from "src/assets/imports/antdComponents";
import { IConfirmationObj } from "src/pages/Studies/models/interfaces";

interface TranscriptModalProps {
	confirmationData: IConfirmationObj;
	onCancel: () => void;
	onConfirm: () => void;
}

const modalStyles = {
	header: { height: "4rem", padding: "1.25rem 1.5rem", margin: 0, background: "#FFF9E6" },
	body: { padding: "1.5rem 0.8rem 1rem 1.5rem" },
	mask: { backdropFilter: "blur(5px)" },
	footer: { padding: "1.5rem", margin: 0 },
	content: { padding: 0, margin: 0 },
};

const ConfirmationDialog: React.FC<TranscriptModalProps> = ({ confirmationData, onCancel, onConfirm }) => {
	const { editType, name, status, visible } = confirmationData;
	const { t } = useTranslation();

	const getIcon = () => {
		switch (status) {
			case "success":
				return <CheckCircleOutlined className="text-green-600 text-xl" />;
			case "error":
				return <CloseCircleOutlined className="text-[--warning-red] text-xl" />;
			case "warning":
				return <ExclamationCircleOutlined className="text-yellow-600 text-xl" />;
			default:
				return null;
		}
	};

	return (
		<Modal
			title={
				<div className="flex items-center justify-between">
					<div className="flex items-center">
						{getIcon()}
						<span className="ml-2 secondary-color text-lg">
							{/* <span className="capitalize">{editType}</span> */}
							{t("Unsaved Changes")}
						</span>
					</div>
					<CloseOutlined className="text-lg cursor-pointer" onClick={onCancel} />
				</div>
			}
			open={visible}
			styles={modalStyles}
			onCancel={onCancel}
			width={420}
			centered
			footer={[
				<>
					<Button onClick={onCancel} className="mr-2">
						{t("Cancel")}
					</Button>
					<Button type="primary" onClick={onConfirm}>
						{t("Yes")}
					</Button>
				</>,
			]}
			closable={false}>
			<p className="text-base-1">
				{t("Unsaved changes in")} <span className="font-semibold secondary-color">'{name}'</span> {t(editType)} {t("will be lost.")}
			</p>
			<p className="text-base-1 mt-6">{t("Do you still want to close?")}</p>
		</Modal>
	);
};

export default ConfirmationDialog;
